import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import { EddResponseModal } from "@NA/Services/ADIEstimatedDeliveryService";
import EddMethodState from "../Data/ADIEddMethodState";
 
const initialState: EddMethodState = {
    isLoading: false,
    eddMethods: null,
};
 
const reducer = {
    "Custom/GetEddMethods": (draft: Draft<EddMethodState>) => {
        draft.isLoading = true;
    },
    "Custom/loadEddMethods": (draft: Draft<EddMethodState>, action: { eddMethods: EddResponseModal }) => {
        draft.isLoading = false;
        draft.eddMethods = action.eddMethods;
    },
}

export default createTypedReducerWithImmer(initialState, reducer);